import React, { useCallback, useState } from "react";
import orImage from "../../../assets/SkuList/or-image.svg";
import image1 from "../../../assets/SkuList/image1.svg";
import uploadImage from "../../../assets/CreateCategory/upload.svg";

import "./style.scss";
import { message, Modal, Spin } from "antd";
import CustomDropZone from "../../../common/CustomDropZone";
import { useDropzone } from "react-dropzone";
import Button from "../../../common/Button";
import SkuList from "../SkuList";
import { useAddActionToAddOnInDraftSku } from "../../../hooks/useOrderBatches";
import orderBatchesApi from "../../../apis/orderBatches";
import guidelinesApi from "../../../apis/guidelines";
import pickerIcon from "../../../assets/UploadColorSwaches/picker.svg";
import { SketchPicker } from "react-color";
import addIcon from "../../../assets/UploadColorSwaches/add-icon.svg";

const UploadColorSwatches = ({
  selectedSku,
  selectedAddOn,
  handleCloseModal,
  isColorCode,
}) => {
  const [isUploadingImage, setIsUploadingImage] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [fileUpload, setFileUpload] = useState({});
  const [imageUrls, setImageUrls] = useState([]);
  const [imageUrl, setImageUrl] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [selectedImageKeys, setSelectedImageKeys] = useState([]);
  const [selectedImageIds, setSelectedImageIds] = useState([]);

  const [formInput, setFormInput] = useState({
    categoryImage: "",
  });
  const { getPresignedUrlForAddOns } = orderBatchesApi;
  const { getThumbPathOfImage } = guidelinesApi;
  const [colorPickers, setColorPickers] = useState([
    { id: 1, selectedType: "hex", inputValue: "" },
  ]);
  const [openPickerId, setOpenPickerId] = useState(null);

  const [sketchPickerColor, setSketchPickerColor] = useState({
    r: "241",
    g: "112",
    b: "19",
    a: "1",
  });

  const { r, g, b, a } = sketchPickerColor;

  const onSuccessaddActionToAddOn = (res) => {
    if (res.status === 200) {
      message.success("Add-On Success");
      handleCloseModal();
    }
  };

  const onErroraddActionToAddOn = (err) => {
    message.error(err);
  };

  const { mutate: addActionToAddOn } = useAddActionToAddOnInDraftSku(
    onSuccessaddActionToAddOn,
    onErroraddActionToAddOn
  );

  const handleImageSelection = (skuImage) => {
    const id = skuImage?._id;
    const key = skuImage.image.thumbPath.key;

    if (selectedAddOn?.actions[0]?.actionTypes[0]?.actionType === "image") {
      setSelectedImageIds([id]);
      setSelectedImageKeys([key]);
    } else if (
      selectedAddOn?.actions[0]?.actionTypes[0]?.actionType === "imageArray"
    ) {
      setSelectedImageIds((prev) =>
        prev.includes(id) ? prev.filter((imgId) => imgId !== id) : [...prev, id]
      );
      setSelectedImageKeys((prev) =>
        prev.includes(key)
          ? prev.filter((imgKey) => imgKey !== key)
          : [...prev, key]
      );
    }
  };

  const transformedColorPickers = colorPickers.map((picker) => ({
    colorMode: picker.selectedType,
    colorValue:
      picker.selectedType === "rgba"
        ? [
            `${picker.color.r}`,
            `${picker.color.g}`,
            `${picker.color.b}`,
            `${picker.color.a}`,
          ]
        : picker.inputValue, // Use the hex or input value
  }));

  const handleAddOnUpdate = () => {
    let payload = {
      skuId: selectedSku?._id,
      serviceId: selectedAddOn?.service,
      packageId: selectedAddOn?.package,
      variantId: selectedAddOn?.variant,
      selectedActionType: selectedAddOn?.actions[0]?.actionTypes[0]?.actionType,
      actionId: selectedAddOn?.actions[0]?._id,
      actionData:
        selectedAddOn?.actions[0]?.actionTypes[0]?.actionType === "imageArray"
          ? selectedImageKeys
          : selectedImageKeys[0],
      metadata: {
        id: selectedImageIds?.map((id) => ({ id })),
      },
    };

    let payloadColorCode = {
      skuId: selectedSku?._id,
      serviceId: selectedAddOn?.service,
      packageId: selectedAddOn?.package,
      variantId: selectedAddOn?.variant,
      selectedActionType: selectedAddOn?.actions[0]?.actionTypes[1]?.actionType,
      actionId: selectedAddOn?.actions[0]?._id,
      actionData:
        selectedAddOn?.actions[0]?.actionTypes[1]?.actionType === "colorArray"
          ? transformedColorPickers
          : "",
    };

    !isColorCode
      ? addActionToAddOn(payload)
      : addActionToAddOn(payloadColorCode);
  };

  const getKeyPresignedMultipleUrl = async (inputFiles) => {
    const files = Array.isArray(inputFiles)
      ? inputFiles
      : Array.from(inputFiles || []);

    const fileNames = files?.map((file) => file?.name);

    if (!fileNames.length) {
      message.error("No valid files detected.");
      return false;
    }

    setImageUrls([]);
    setIsUploadingImage(true);

    let uploadSuccess = true;

    try {
      const uploadedKeys = await Promise.all(
        files.map(async (file, index) => {
          if (!file || !file?.name || !file?.type) {
            uploadSuccess = false;
            throw new Error(
              `Invalid file detected at index ${index}. Ensure all files have a valid name and type.`
            );
          }

          const resp = await getPresignedUrlForAddOns({
            filename: file?.name,
            mimeType: file?.type,
          });

          if (resp?.status !== 200 || !resp?.data?.key || !resp?.data?.url) {
            uploadSuccess = false;
            throw new Error("Invalid response from getPresignedUrl.");
          }

          const { key, url } = resp.data;

          const uploadResp = await fetch(url, {
            method: "PUT",
            headers: {
              "Content-Type": file?.type,
            },
            body: file,
          });

          if (!uploadResp.ok) {
            uploadSuccess = false;
            throw new Error(
              `File upload failed with status: ${uploadResp.status}`
            );
          }

          const thumbResp = await getThumbPathOfImage({ key });
          setImageUrls((prev) => [
            ...prev,
            thumbResp?.data?.data?.thumbPath?.url,
          ]);

          return key;
        })
      );

      if (uploadSuccess) {
        setSelectedImageKeys(uploadedKeys);
        console.log("selected", selectedImageIds);
        message.success("All images uploaded successfully.");
      } else {
        message.error("Some images failed to upload.");
      }
    } catch (err) {
      console.error("Upload Error:", err);
      uploadSuccess = false;
      message.error(
        err?.response?.data?.message ||
          err.message ||
          "An error occurred during upload."
      );
    } finally {
      setIsUploadingImage(false);
    }

    return uploadSuccess;
  };

  const handleActions = () => {
    return (
      selectedAddOn?.actions[0]?.actionTypes[0]?.actionType === "imageArray"
    );
  };

  const getKeyPresignedUrl = async (file) => {
    let uploadSuccess = true;
    setIsSuccess(true);

    // Check if file is valid and has at least one element
    if (!file || !file[0]?.name || !file[0]?.type) {
      uploadSuccess = false;
      setIsSuccess(false);
      throw new Error(
        "Invalid file detected. Ensure the file has a valid name and type."
      );
    }

    try {
      const resp = await getPresignedUrlForAddOns({
        filename: file[0]?.name,
        mimeType: file[0]?.type,
      });

      if (resp?.status !== 200 || !resp?.data?.key || !resp?.data?.url) {
        uploadSuccess = false;
        setIsSuccess(false);
        throw new Error("Invalid response from getPresignedUrl.");
      }

      const { key, url } = resp.data;

      const uploadResp = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": file[0].type,
        },
        body: file[0],
      });

      if (!uploadResp.ok) {
        uploadSuccess = false;
        setIsSuccess(false);
        throw new Error(`File upload failed with status: ${uploadResp.status}`);
      }

      if (uploadSuccess) {
        setIsSuccess(true);
        getThumbPathOfImage({
          key,
        }).then((resp) => {
          setImageUrl(resp?.data?.data?.thumbPath?.url);
        });
        const addFilesPayload = key;
        setSelectedImageKeys(addFilesPayload);
        setIsSuccess(true);
        message.success("Image uploaded successfully.");
      } else {
        message.error("Some images failed to upload.");
      }
    } catch (err) {
      uploadSuccess = false;
      setIsSuccess(false);
      message.error(
        err?.response?.data?.message ||
          err.message ||
          "An error occurred during upload."
      );
    } finally {
      setIsUploadingImage(false);
    }
    return uploadSuccess;
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      "image/jpg": "",
      "image/png": "",
      "image/jpeg": "",
      "image/webp": "",
    },
    onDrop: (acceptedFiles) => {
      if (acceptedFiles.length > 0) {
        setImageUrl("");
        setFileUpload({});
        setFormInput((prev) => ({
          ...prev,
          categoryImage: acceptedFiles[0],
        }));
      }
      setIsUploadingImage(true);
      setIsDragging(false);
      getKeyPresignedUrl(acceptedFiles);
    },
    multiple: false,
  });

  const onDropItems = async (file) => {
    if (file?.length > 0) {
      setImageUrl("");
      setFileUpload({});
      setFormInput((prev) => ({
        ...prev,
        categoryImage: file[0],
      }));
      setIsUploadingImage(true);
      setIsDragging(false);
      handleActions()
        ? getKeyPresignedMultipleUrl(file)
        : getKeyPresignedUrl(file);
    } else {
      console.error("No file dropped");
    }
  };

  const handleDragEnter = useCallback((e) => {
    e.preventDefault();
    setIsDragging(true);
  }, []);

  const handleDragLeave = useCallback((e) => {
    e.preventDefault();
    setIsDragging(false);
  }, []);

  const renderDragAndDropSection = useCallback(
    () =>
      isDragging && (
        <CustomDropZone
          dropZoneClass={"uploaded_images_row"}
          onDropItems={() => onDropItems()}
          isShowTextOnDrag={true}
          acceptingFormates={{
            "image/jpg": "",
            "image/png": "",
            "image/jpeg": "",
            "image/webp": "",
          }}
          handleDragLeave={handleDragLeave}
          multiple={handleActions() ? true : false}
        />
      ),
    [isDragging, onDropItems, handleDragLeave]
  );

  const handleAreaClick = () => {
    document?.getElementById("file")?.click();
  };

  const getUploadWrapper = () => {
    return (
      <>
        {isSuccess ? (
          <div className="upload_image_wrapper">
            <div className="image_container">
              {handleActions() ? (
                imageUrl?.map((image) => {
                  return <img src={image} alt="" />;
                })
              ) : (
                <img src={imageUrl} alt="" />
              )}
              <div
                className="cross-icon"
                onClick={() => {
                  setIsSuccess(false);
                  setFormInput((prev) => ({
                    ...prev,
                    categoryImage: "", // Clear only the image field
                  }));
                }}
              ></div>
            </div>
          </div>
        ) : (
          <>
            <div className="image">
              <img src={uploadImage} alt="" />
            </div>
            <h2>Drag your file(s) to start uploading</h2>
            <input
              type="file"
              multiple={handleActions()}
              accept="image/png,image/jpg,image/jpeg,image/webp"
              id="file"
              onChange={(e) => {
                const files = e?.target?.files;
                handleUploadImage(files);
              }}
              onClick={(e) => (e.target.value = null)}
              className="upload_more_images_btn_input"
            />
          </>
        )}
      </>
    );
  };

  const handleUploadImage = async (file) => {
    if (file.length > 0) {
      setImageUrl("");
      setFileUpload({});
      setFormInput((prev) => ({
        ...prev,
        categoryImage: file[0],
      }));
      setIsUploadingImage(true);
      handleActions()
        ? getKeyPresignedMultipleUrl(file)
        : getKeyPresignedUrl(file);
    }
  };

  const handleAddMoreColors = () => {
    setColorPickers((prevPickers) => [
      ...prevPickers,
      {
        id: prevPickers.length + 1,
        selectedType: "rgba",
        inputValue: "255, 255, 255, 1",
        color: { r: 255, g: 255, b: 255, a: 1 },
      },
    ]);
  };

  const handleSelectChange = (id, type) => {
    setColorPickers((prevPickers) =>
      prevPickers.map((picker) =>
        picker.id === id
          ? {
              ...picker,
              selectedType: type,
              inputValue: type === "rgba" ? "255, 255, 255, 1" : "#ffffff",
              color:
                type === "rgba" ? { r: 255, g: 255, b: 255, a: 1 } : "#ffffff",
            }
          : picker
      )
    );
  };

  const handleColorChange = (id, color) => {
    setColorPickers((prevPickers) =>
      prevPickers.map((picker) =>
        picker.id === id
          ? {
              ...picker,
              inputValue:
                picker.selectedType === "rgba"
                  ? `${color.rgb.r}, ${color.rgb.g}, ${color.rgb.b}, ${color.rgb.a}`
                  : color.hex,
              color: picker.selectedType === "rgba" ? color.rgb : color.hex,
            }
          : picker
      )
    );
  };

  const togglePicker = (id) => {
    setOpenPickerId(openPickerId === id ? null : id);
  };

  return (
    <div className="upload_color_swaches">
      <div className="upload_wrapper">
        <div className="container">
          <div className="select_upload" onDragEnter={handleDragEnter}>
            <div className="upload_top_section">
              {!isColorCode ? (
                <div className="uploadText">Upload Images</div>
              ) : (
                ""
              )}
              {isColorCode && (
                <div className="color_code">Updated Color Code</div>
              )}
            </div>
            {!isColorCode ? (
              <div
                className="upload_section"
                onClick={(e) => handleAreaClick()}
              >
                {isUploadingImage ? <Spin /> : getUploadWrapper()}
                {renderDragAndDropSection()}
              </div>
            ) : (
              <div className="color_code_section">
                <div className="color_palette">
                  {colorPickers.map((picker, index) => (
                    <div key={picker.id} className="color_options">
                      <select
                        value={picker.selectedType}
                        onChange={(e) =>
                          handleSelectChange(picker.id, e.target.value)
                        }
                      >
                        <option value="hex">Hex</option>
                        <option value="rgba">RGBA</option>
                      </select>
                      <input type="text" value={picker.inputValue} readOnly />
                      <div
                        className="color_picker"
                        onClick={() => togglePicker(picker.id)}
                      >
                        <img src={pickerIcon} alt="" />
                        {openPickerId === picker.id && (
                          <div className="sketch_wrapper">
                            <SketchPicker
                              onChange={(color) =>
                                handleColorChange(picker.id, color)
                              }
                              color={sketchPickerColor}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
                <button
                  className="add_more_colors"
                  onClick={handleAddMoreColors}
                >
                  <img src={addIcon} alt="" />
                  Add more colors
                </button>
              </div>
            )}
          </div>
          {!isColorCode ? (
            <div className="sku_listing">
              {selectedSku.files.map((skuImage, index) => {
                const isSelected = selectedImageIds?.includes(skuImage?._id);
                return (
                  <div
                    className="image_container"
                    onClick={() => handleImageSelection(skuImage)}
                    key={skuImage?._id}
                  >
                    <div
                      className={`image ${isSelected ? "sku_selected" : ""}`}
                    >
                      <img
                        src={skuImage.image.thumbPath.url}
                        alt={skuImage.image.name}
                      />
                    </div>
                    <span>{skuImage.image.name}</span>
                  </div>
                );
              })}
            </div>
          ) : (
            ""
          )}
          <div className="add_action_btn">
            <Button
              text="Add"
              width="136px"
              height="55px"
              showIcon={false}
              handleClick={handleAddOnUpdate}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadColorSwatches;
